import React from 'react'
import { Action, IOWidget, mk_widget } from 'widgets-for-react'

import { CMSState, Link } from '../types.gen'
import { link, getClassName } from '../utils.gen'

export type TextBlockProps<CustomBlockData, extra_images> = {
  title?: string
  text: string
  primary_button?: ({ kind: 'button'; on_click: () => Action<CMSState<CustomBlockData, extra_images, never>> } | Link) & {
    title: string
  }
  link?: Link

  show_in_page_navigation: boolean
  navigation_title: string
}

export type TextBlockStyle = Partial<{
  block_classname: string
  inner_classname: string
  header_classname: string
  title_classname: string
  content_classname: string
  text_classname: string
  footer_classname: string
  clickable_primary_classname: string
  clickable_secondary_classname: string
}>

// This block is not used

export function TextBlock<CustomBlockData, extra_images>(
  props: TextBlockProps<CustomBlockData, extra_images>,
  options?: { style?: TextBlockStyle; key?: string }
): IOWidget<CMSState<CustomBlockData, extra_images, never>, Action<CMSState<CustomBlockData, extra_images, never>>> {
  return (s: CMSState<CustomBlockData, extra_images, never>) =>
    mk_widget({
      run: onDone => (
        <section
          id={props.navigation_title}
          className={getClassName(options, 'block_classname', 'container')}
          key={options && options.key ? options.key : 'text-block'}
        >
          <div className={getClassName(options, 'inner_classname', 'py-5')}>
            {props.title ?
              <header className={getClassName(options, 'header_classname', '')}>
                <h2
                  className={getClassName(options, 'title_classname', 'mb-3')}
                  dangerouslySetInnerHTML={{ __html: props.title }}
                />
              </header>
              : null}

            <div className={getClassName(options, 'content_classname', '')}>
              <div
                className={getClassName(options, 'text_classname', '')}
                dangerouslySetInnerHTML={{ __html: props.text }}
              />
            </div>

            {(props.primary_button || (props.link && props.link.title && props.link.url)) && (
              <footer className={getClassName(options, 'footer_classname', '')}>
                {props.primary_button ? (
                  props.primary_button.kind === 'button' ? (
                    <button
                      className={getClassName(options, 'clickable_primary_classname', 'btn btn-dark')}
                      onClick={() => props.primary_button.kind === 'button' && onDone(props.primary_button.on_click())}
                    >
                      {props.primary_button.title}
                    </button>
                  ) : props.primary_button.title && props.primary_button.url ? (
                    link(
                      props.primary_button,
                      { classname: getClassName(options, 'clickable_primary_classname', 'btn btn-dark') },
                      props.primary_button.title
                    )
                  ) : null
                ) : null}
                {props.link &&
                  props.link.title &&
                  props.link.url &&
                  link(
                    props.link,
                    { classname: getClassName(options, 'clickable_secondary_classname', 'btn btn-link ml-2') },
                    props.link.title
                  )}
              </footer>
            )}
          </div>
        </section>
      )
    })
}



// WEBPACK FOOTER //
// ./Client/components/cms/blocks/widgets/textBlock.gen.tsx